<template>
  <div class="create-lead-form">
    <div class="field">
      <label for="">First name <span>*</span></label>
      <input v-model="store.createLeadData.first_name" type="text" />
    </div>

    <div class="field">
      <label for="">Last name <span>*</span></label>
      <input v-model="store.createLeadData.last_name" type="text" />
    </div>

    <!-- Phone (يدعم تعدد الأرقام + اسم لكل رقم) -->
    <div class="field">
      <div class="field-label-with-action">
        <label>Phone <span>*</span></label>
        <v-btn
          icon
          size="small"
          class="mini-btn"
          @click="addPhone"
          :title="'Add phone'"
        >
          <v-icon size="16">mdi-plus</v-icon>
        </v-btn>
      </div>

      <div
        v-for="(ph, i) in store.createLeadData.phones"
        :key="'ph-' + i"
        class="multi-input-row"
      >
        <input
          v-model="ph.phone_name"
          type="text"
          placeholder="Name"
          style="flex: 0 0 30%"
        />
        <input
          v-model="ph.phone"
          type="tel"
          placeholder="Phone number"
          style="flex: 1"
        />
        
      </div>
    </div>

    <!-- Email (يدعم تعدد الإيميلات) -->
    <div class="field">
      <div class="field-label-with-action">
        <label>Email</label>
        <v-btn
          icon
          size="small"
          class="mini-btn"
          @click="addEmail"
          :title="'Add email'"
        >
          <v-icon size="16">mdi-plus</v-icon>
        </v-btn>
      </div>

      <div
        v-for="(em, i) in store.createLeadData.emails"
        :key="'em-' + i"
        class="multi-input-row"
      >
        <input v-model="store.createLeadData.emails[i]" type="email" />
        <v-btn
          v-if="store.createLeadData.emails.length > 1"
          icon
          size="small"
          class="mini-btn danger"
          @click="removeEmail(i)"
          :title="'Remove'"
        >
          <v-icon size="16">mdi-close</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="field">
      <label for="">Date & Time <span>*</span></label>
      <VueDatePicker
        v-model="store.createLeadData.lead_genration_time"
      ></VueDatePicker>
    </div>

    <div class="field">
      <label for="">Progress Status <span>*</span></label>
      <v-select
        v-model="store.progress_status"
        :items="progress_status_list"
        class="contact-v-select w-100"
        variant="outlined"
        hide-details
        placeholder="Select Progress Status"
        return-object
      >
        <template #item="{ item }">
          <v-list-item @click="setValue(item)" style="padding: 0">
            <div class="w-100 pa-2">
              {{ item.title }}
            </div>
          </v-list-item>
        </template>
      </v-select>
    </div>

    <div class="field">
      <label for="">Note </label>
      <textarea
        v-model="store.createLeadData.note"
        name=""
        id=""
        cols="30"
        rows="10"
      ></textarea>
    </div>

    <div class="select-field">
      <label for="">Source <span>*</span></label>
      <v-select
        hide-details
        return-object
        v-model="store.leadSource"
        :items="store.leadSources"
        @update:modelValue="updateLeadSource"
        variant="outlined"
        class="custom-v-select"
        no-details
        placeholder="Select Source"
      >
        <!-- تخصيص عرض العناصر داخل القائمة -->
        <template v-slot:item="{ item, props }">
          <v-list-item
            @click="selectedSource(item)"
            v-bind="props"
            :title="item.raw.title"
          >
          </v-list-item>
        </template>

        <!-- تخصيص عرض القيمة المختارة -->
        <template v-slot:selection="{ item }">
          <div class="d-flex align-center">
            {{ item.raw.title }}
          </div>
        </template>
      </v-select>
    </div>

    <div class="select-field">
      <label for="">Agent <span>*</span></label>
      <v-select
        @click="store.getAgencies()"
        hide-details
        return-object
        v-model="store.selectedAgency"
        :items="store.arr_agency"
        variant="outlined"
        class="custom-v-select"
        placeholder="Select Agency"
        no-details
      >
        <template v-slot:item="{ item }">
          <v-list-item @click="selectedAgency(item)">
            <div class="d-flex align-center gap-5">
              <img
                :src="item.raw.image"
                alt=""
                style="
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  object-fit: cover;
                  display: flex;
                "
              />
              <span style="display: flex">{{
                item.raw.first_name + " " + item.raw.last_name
              }}</span>
            </div>
          </v-list-item>
        </template>
        <template v-slot:selection="{ item }">
          <div class="d-flex align-center gap-2">
            <img
              :src="item.raw.image"
              alt=""
              style="
                width: 24px;
                height: 24px;
                border-radius: 50%;
                object-fit: cover;
                display: flex;
              "
            />
            <span style="display: flex">{{
              item.raw.first_name + " " + item.raw.last_name
            }}</span>
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import VueDatePicker from "@vuepic/vue-datepicker";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import { useGeneralStore } from "@/store/General";

export default {
  name: "createLeadForm",
  components: {
    VueDatePicker,
  },
  data() {
    return {
      store: useLeadsStore(),
      generalStore: useGeneralStore(),
      progress_status: "",
      progress_status_list: ["New", "In Progress", "Recycled", "Dead"],
    };
  },
  mounted() {
    if (
      !Array.isArray(this.store.createLeadData.phones) ||
      !this.store.createLeadData.phones.length
    ) {
      this.store.createLeadData.phones = [
        { id: null, phone_name: "", phone: "" },
      ];
    }

    if (!Array.isArray(this.store.createLeadData.emails)) {
      const v = this.store.createLeadData.email || "";
      this.store.createLeadData.emails = v ? [v] : [""];
    }

    this.store.getAllLeads?.();
  },

  methods: {
    setValue(item) {
      console.log(item);
      this.store.progress_status = item.value;
    },
    selectedAgency(item) {
      this.store.selectedAgency = item.raw;
      this.store.createLeadData.agent_id = item.raw.id;
      console.log("Selected Agency:", this.store.createLeadData.agent_id);
    },
    updateLeadStatus() {
      this.store.leadStatus = this.store.leadStatuses.find(
        (item) => item.value === this.store.leadStatus.value
      );
    },
    selectedStatus(item) {
      console.log("Selected Status:", item.raw.value);
      this.store.createLeadData.status = item.raw.value;
    },
    updateLeadSource() {
      this.store.leadSource = this.store.leadSources.find(
        (item) => item.value === this.store.leadSource.value
      );
    },
    selectedSource(item) {
      console.log("Selected Source:", item.raw.value);
      this.store.createLeadData.source = item.raw.value;
    },
    updateLeadAgency(newValue) {
      this.store.selectedAgency = newValue;
      console.log("Selected Agency:", newValue);
    },
    showSuccessMessage() {
      this.generalStore.showSnackbar("Lead created successfully", "success");
    },
    addPhone() {
      if (!Array.isArray(this.store.createLeadData.phones)) {
        this.store.createLeadData.phones = [
          { id: null, phone_name: "", phone: "" },
        ];
      } else {
        this.store.createLeadData.phones.push({
          id: null,
          phone_name: "",
          phone: "",
        });
      }
    },
    removePhone(i) {
      this.store.createLeadData.phones.splice(i, 1);
    },
    addEmail() {
      if (!Array.isArray(this.store.createLeadData.emails)) {
        this.store.createLeadData.emails = [""];
      }
      this.store.createLeadData.emails.push("");
    },
    removeEmail(i) {
      this.store.createLeadData.emails.splice(i, 1);
    },
    buildPayload() {
      // حضّر مصفوفتين منفصلتين
      const phoneNumbers = [];
      const phoneLabels = [];

      (this.store.createLeadData.phones || []).forEach((p) => {
        const num = (p.phone || "").trim();
        const lab = (p.label || "").trim();

        if (num) {
          phoneNumbers.push(num);
          phoneLabels.push(lab);
        }
      });

      const payload = {
        ...this.store.createLeadData,

        phone_numbers: phoneNumbers,
        phone_labels: phoneLabels,
        emails: (this.store.createLeadData.emails || [])
          .map((s) => (s || "").trim())
          .filter(Boolean),
      };

      return payload;
    },
  },

  computed: {},
};
</script>

<style scoped>
::v-deep(.contact-v-select) {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  padding: 0px;
  outline: none;
}
::v-deep(.contact-v-select .v-field__outline) {
  display: none !important;
}
.field-label-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.multi-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
}

.mini-btn {
  border: 1px dashed transparent;
  box-shadow: none !important;
}

.mini-btn.danger {
  border-color: #f3b2b2;
}
</style>
